const noop = function () {};
window.pageLoadFinish = noop;
window.nativeWebWillAppear = noop;
window.webviewAppear = noop;
window.webviewDisappear = noop;
window.onNetStateChange = noop;
window.nativeResponseAudioStatus = noop;
window.nativeResponseAudioProgress = noop;
window.getNativeFetusActionDataCallBack = noop;
window.downloadImageToNativeAlbumCallBack = noop;
window.notifyH5MoveMentPlayStatusCallBack = noop;
window.backOrderInfo = noop;
window.thridShareSuccess = noop;
window.getLoadTime = noop;
window.selectionAddressCall = noop;
window.refreshTDSquare = noop;
window.installSharePlatform = noop;
window.share = window.share || {};
window.share.success = noop;
window.nativeGetNetStateFinishCall = noop;
if (window.android) {
  window.android.nativeGetNetState = noop;
  window.android.nativeArousePayCallback = noop;
  window.android.getLoadTime = noop;
  window.android.adAction = noop;
}

// 禁用 React DevTools 的错误上报功能，防止向 reactjs.org 发送请求
// 默认禁用错误上报，如需启用可通过环境变量 ENABLE_REACT_ERROR_REPORTING=true 控制
if (typeof window !== 'undefined') {
  // 检查是否启用错误上报（默认禁用）
  const enableErrorReporting = window.__ENABLE_REACT_ERROR_REPORTING__ === true;

  if (!enableErrorReporting) {
    // 禁用 React DevTools 的全局 hook，防止错误上报
    if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
      // 重写相关方法，禁用错误上报
      if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onCommitFiberRoot) {
        window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onCommitFiberRoot = noop;
      }
      if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onCommitFiberUnmount) {
        window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onCommitFiberUnmount = noop;
      }
      // 禁用 React DevTools 的错误处理
      if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onError) {
        window.__REACT_DEVTOOLS_GLOBAL_HOOK__.onError = noop;
      }
      // 禁用其他可能导致网络请求的方法
      if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__.renderers) {
        window.__REACT_DEVTOOLS_GLOBAL_HOOK__.renderers = new Map();
      }
    }

    // 完全移除 React DevTools 的全局 hook，防止任何可能的错误上报请求
    try {
      Object.defineProperty(window, '__REACT_DEVTOOLS_GLOBAL_HOOK__', {
        value: undefined,
        writable: false,
        configurable: false
      });
    } catch (e) {
      // 如果无法定义，尝试删除
      try {
        delete window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
      } catch (e2) {
        // 忽略错误
      }
    }
  }

  // 禁用 prop-types 对 fb.me/use-check-prop-types 的调用
  // 拦截所有对 fb.me 和 facebook.com 域名的网络请求

  // 方法1: 拦截 fetch API 请求
  const originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function (...args) {
      const url = args[0];
      const urlString =
        typeof url === 'string' ? url : url && url.url ? url.url : '';
      if (
        urlString &&
        (urlString.indexOf('fb.me') > -1 ||
          urlString.indexOf('facebook.com') > -1)
      ) {
        // 阻止对 fb.me 和 facebook.com 的请求
        return Promise.reject(
          new Error('Blocked request to fb.me/facebook.com')
        );
      }
      return originalFetch.apply(this, args);
    };
  }

  // 方法2: 拦截 XMLHttpRequest 请求
  const originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (
      typeof url === 'string' &&
      (url.indexOf('fb.me') > -1 || url.indexOf('facebook.com') > -1)
    ) {
      // 阻止对 fb.me 和 facebook.com 的请求
      throw new Error('Blocked request to fb.me/facebook.com');
    }
    return originalXHROpen.call(this, method, url, ...rest);
  };

  // 方法3: 拦截通过 Image 对象加载的请求（用于 1x1 像素追踪）
  // prop-types 可能会通过创建 Image 对象并设置 src 来发送追踪请求
  const originalImage = window.Image;
  if (originalImage) {
    window.Image = function (...args) {
      const img = new originalImage(...args);
      // 拦截 src 属性的设置
      const originalSrcDescriptor = Object.getOwnPropertyDescriptor(
        HTMLImageElement.prototype,
        'src'
      );
      if (originalSrcDescriptor && originalSrcDescriptor.set) {
        Object.defineProperty(img, 'src', {
          set: function (value) {
            if (
              typeof value === 'string' &&
              (value.indexOf('fb.me') > -1 ||
                value.indexOf('facebook.com') > -1)
            ) {
              // 阻止加载 fb.me 和 facebook.com 的图片
              return;
            }
            originalSrcDescriptor.set.call(this, value);
          },
          get: function () {
            return originalSrcDescriptor.get
              ? originalSrcDescriptor.get.call(this)
              : '';
          },
          configurable: true
        });
      }
      return img;
    };
  }

  // 方法4: 重写 console.error 来过滤 prop-types 相关的警告
  // prop-types 可能会在 console.error 中输出包含 fb.me 链接的警告
  const originalConsoleError = console.error;
  console.error = function (...args) {
    const message = args.map(arg => String(arg)).join(' ');
    // 如果错误信息包含 fb.me 或 use-check-prop-types，不输出
    if (
      message.indexOf('fb.me') > -1 ||
      message.indexOf('use-check-prop-types') > -1 ||
      message.indexOf('facebook.com') > -1
    ) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
}
